import { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { SeoIssueListParams } from '../api/seo-api';
import { SEO_ISSUE_FILTER_FIELDS, SEO_ISSUE_SORTS } from '../components/seo-issue-filters';

/**
 * URL search params of the SEO issues list; mirrors GET .../seo/issues. Without `status` the
 * backend lists open issues, so an absent value means open here too.
 */
export const seoIssueSearchSchema = indexSearchSchema(SEO_ISSUE_FILTER_FIELDS, {
  sort: SEO_ISSUE_SORTS,
})
  // No text search on this endpoint. The router keeps a param the schema leaves out, so `q` is
  // read and thrown away instead.
  .extend({ q: z.undefined().catch(undefined) });

export type SeoIssueSearch = z.infer<typeof seoIssueSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function seoIssueListParams(search: SeoIssueSearch): SeoIssueListParams {
  return listParams(search, SEO_ISSUE_FILTER_FIELDS);
}
